import React from "react";
import { CASE_STUDIES } from "../mock/mock";

// Marquee strip of brand names, dual loop for seamless scroll.
const LogoMarquee = () => {
  const items = [...CASE_STUDIES, ...CASE_STUDIES];
  return (
    <section className="bg-white text-black border-y border-black/10 overflow-hidden">
      <div className="py-10">
        <div className="flex w-[200%] animate-marquee">
          {items.map((c, i) => (
            <div
              key={`${c.brand}-${i}`}
              className="shrink-0 px-10 flex items-center gap-10"
            >
              <span className="font-serif-display italic font-black text-3xl md:text-5xl whitespace-nowrap">
                {c.brand}
              </span>
              <span className="w-2 h-2 rounded-full bg-black/60" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoMarquee;
